import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import { Markup } from "interweave";
import WOW from "wowjs";
import Button from "../../component/Button/Button";

import "react-quill/dist/quill.snow.css";

import useWindowDimensions from "../../useWindowDimensions";

import "./style.less";
import bg from "../../images/404/bg.jpg";

const Maintainence = (props) => {
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    window.scroll(0, 0);
    document.title = "Hos - Maintainence";

    new WOW.WOW({
      live: false,
    }).init();
  }, []);
  return (
    <>
      <section
        className="pagenotfoundsec1 wow fadeIn t-c maintainence"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <p style={{fontSize: '3.5em'}}>Sorry, we are down for maintenance.</p>
        <h3>We will be back up shortly.</h3>
        {/* <h1>500</h1>
        <Button
          onClick={() => props.history.push("/")}
          title="BACK TO HOMEPAGE"
        /> */}
      </section>
    </>
  );
};

export default Maintainence;
